import React, { useCallback } from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';

import Slider from '@react-native-assets/slider';

// eslint-disable-next-line import/no-extraneous-dependencies
import VolumeOffIcon from 'assets/images/svgs/Player/ico_volume_off.svg';
import VolumeOnIcon from 'assets/images/svgs/Player/ico_volume_on.svg';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { COLOR, whiteTransparent } from 'utils/colors';

import styles from './styles';

type Props = {
    volume: number;
    onChangeVolume(volume: number): void;
    onProlongOverlayVisiblity(action: () => void): void;
};

const {
    ACCESSIBILITY: {
        PLAYER: {
            ACCESSIBILITY_PLAYER_VOLUME_BAR,
            ACCESSIBILITY_PLAYER_UNMUTE,
            ACCESSIBILITY_PLAYER_MUTE,
        },
    },
} = LANGUAGE_KEYS;

function VolumeControl({
    volume,
    onChangeVolume,
    onProlongOverlayVisiblity,
}: Props) {
    const { t } = useTranslation();

    const handleVolumeChanged = useCallback(
        (value: number) => {
            onProlongOverlayVisiblity(() => onChangeVolume(value));
        },
        [onChangeVolume, onProlongOverlayVisiblity],
    );

    return (
        <View style={styles.container}>
            <VolumeOnIcon
                style={styles.icon}
                accessibilityLabel={t(ACCESSIBILITY_PLAYER_MUTE)}
            />
            <Slider
                vertical
                inverted
                style={styles.slider}
                value={volume}
                minimumTrackTintColor={COLOR.NEUTRAL}
                maximumTrackTintColor={whiteTransparent(0.2)}
                minimumValue={0}
                maximumValue={1}
                thumbTintColor={COLOR.NEUTRAL}
                thumbSize={20}
                // @ts-ignore
                onValueChange={handleVolumeChanged}
                onSlidingComplete={handleVolumeChanged}
                accessibilityLabel={t(ACCESSIBILITY_PLAYER_VOLUME_BAR)}
            />
            <VolumeOffIcon
                style={styles.icon}
                accessibilityLabel={t(ACCESSIBILITY_PLAYER_UNMUTE)}
            />
        </View>
    );
}

export default VolumeControl;
